module.exports = __webpack_public_path__ + "img/target_visualization.febf9383.jpg";